import React from "react";

const AdsTxt = () => {
  return (
    <json>google.com, pub-2092053768861698, DIRECT, f08c47fec0942fa0</json>
  );
};

export default AdsTxt;
